import * as Yup from 'yup';

export const applicationOptionSchema = Yup.object().shape({
    name: Yup.string()
        .max(255, 'Name must not exceed 255 characters')
        .required('Name is required'),
    value: Yup.string()
        .required('Value is required'),
    dataType: Yup.string()
        .max(255, 'Data type must not exceed 255 characters')
        .required('Data type is required'),
    description: Yup.string()
        .max(255, 'Description must not exceed 255 characters')
        .nullable(),
});
